import { gql } from "@apollo/client";

export const REQUEST_CANDIDATE_ATTACHMENT_UPLOAD = gql`
  mutation RequestCandidateAttachmentUpload($input: RequestCandidateAttachmentUploadInput!) {
    requestCandidateAttachmentUpload(input: $input) {
      uploadUrl
      formFields {
        key
        value
      }
      storageKey
      originalFileName
      uploadTimestamp
    }
  }
`;

export const CONFIRM_CANDIDATE_ATTACHMENT_UPLOAD = gql`
  mutation ConfirmCandidateAttachmentUpload($input: ConfirmCandidateAttachmentUploadInput!) {
    confirmCandidateAttachmentUpload(input: $input) {
      id
      candidateId
      originalFileName
      contentType
      fileSizeBytes
      attachmentType
      description
      uploadedById
      uploadedByName
      createdAtUtc
      updatedAtUtc
    }
  }
`;

export const REQUEST_JOB_ATTACHMENT_UPLOAD = gql`
  mutation RequestJobAttachmentUpload($input: RequestJobAttachmentUploadInput!) {
    requestJobAttachmentUpload(input: $input) {
      uploadUrl
      formFields {
        key
        value
      }
      storageKey
      originalFileName
      uploadTimestamp
    }
  }
`;

export const CONFIRM_JOB_ATTACHMENT_UPLOAD = gql`
  mutation ConfirmJobAttachmentUpload($input: ConfirmJobAttachmentUploadInput!) {
    confirmJobAttachmentUpload(input: $input) {
      id
      jobId
      originalFileName
      contentType
      fileSizeBytes
      attachmentType
      description
      uploadedById
      uploadedByName
      createdAtUtc
      updatedAtUtc
    }
  }
`;

export const DELETE_CANDIDATE_ATTACHMENT = gql`
  mutation DeleteCandidateAttachment($attachmentId: String!) {
    deleteCandidateAttachment(attachmentId: $attachmentId)
  }
`;

export const DELETE_JOB_ATTACHMENT = gql`
  mutation DeleteJobAttachment($attachmentId: String!) {
    deleteJobAttachment(attachmentId: $attachmentId)
  }
`;

